<!-- 配件返厂 -->
<template>
  <div>
    <div class="detail-wrap">
      <el-form ref="editForm" :model="tenant">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            结算单号：<span v-if="formData.settleNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.settleNo }}</span>
            <span v-else class="information"> 待生成</span>

            <!-- 工单状态 -->
            <span v-if="!dataId" class="information"> 申请</span>
            <span v-else-if="formData.stat == 1" class="information">结算生成</span>
            <span v-else-if="formData.stat == 2" class="information">待确认</span>
            <span v-else-if="formData.stat == 3" class="information">已确认</span>
            <span v-else-if="formData.stat == 4" class="information">异议</span>
            <span v-else-if="formData.stat == 11" class="information">待开票</span>
            <span v-else-if="formData.stat == 13" class="information">已开票</span>
            <span v-else-if="formData.stat == 15" class="information">已收票</span>
            <span v-else-if="formData.stat == 29" class="information">已结算</span>
            <span v-else-if="formData.stat == 99" class="information">取消</span>
          </div>
          <div>

            <el-button type="primary" v-if="applicationHandle && formData.stat == 4" plain class="button-sty"
              @click="handleCommand('异议处理', formData.id)" icon="el-icon-tickets">异议处理</el-button>
            <el-button type="primary"
              v-if="applicationAdjust && (formData.stat == 1 || formData.stat == 2 || formData.stat == 3 || formData.stat == 4)" plain
              class="button-sty" @click="handleCommand('调整金额', formData.id)" icon="el-icon-tickets">调整金额</el-button>
            <el-button type="primary" v-if="applicationInvoice && formData.stat == 13" plain class="button-sty"
              @click="handleCommand('收票', formData.id)" icon="el-icon-tickets">收票</el-button>

            <el-button type="primary" v-if="applicationReject && formData.stat == 13" plain class="button-sty"
                       @click="handleCommand('驳回', formData.id)" icon="el-icon-tickets">驳回</el-button>

            <!-- <el-button type="primary" v-if="applicationExport" plain class="button-sty" @click="handleCommand('导出流水',formData.id)" icon="el-icon-tickets">导出流水</el-button> -->
            <el-button type="primary" v-if="applicationConfirm && formData.stat == 2" plain class="button-sty"
              @click="handleCommand('确认', formData.id)" icon="el-icon-tickets">确认</el-button>
<!--            <el-button type="primary" v-if="applicationUpload && formData.stat == 11" plain class="button-sty"-->
<!--              @click="handleCommand('上传发票', formData.id)" icon="el-icon-tickets">上传发票</el-button>-->
            <el-button type="primary" v-if="applicationUpload && formData.stat == 11" plain class="button-sty"
                       @click="handleCommand('付款申请', formData.id)" icon="el-icon-tickets">付款申请</el-button>

<!--            <el-button type="primary" v-if="zbApplicationUpload && formData.stat == 11 && companyShortName == '纽恩泰' && !isSite" plain class="button-sty"
                       @click="handleCommand('代开发票', formData.id)" icon="el-icon-tickets">代开发票</el-button>-->

            <el-button type="primary" v-if="applicationLine" plain class="button-sty"
              @click="viewApplicationDetails(formData.id)" icon="el-icon-tickets">查看明细</el-button>
            <el-button type="primary" v-if="sfBatchSettleLineExport" plain class="button-sty" @click="doExcleDetail"
              icon="el-icon-upload2">导出明细</el-button>

          </div>
        </div>

        <div>
          <!-- 基本信息 -->
          <dix style="display: flex;  overflow: unset!important;
            overflow-y: scroll!important;
            height: 100vh!important; ">
            <div class="d-cont edit-mce-box" style="width: 80%;">
              <div class="d-item">
                <div class="title first"><b>业务信息</b></div>
                <table class="table-detail">
                  <tbody>

                    <tr>
                      <th>机构名称</th>
                      <td>{{ formData.orgName }}</td>

                      <th>网点</th>
                      <td>{{ formData.siteName }}</td>
                    </tr>
                    <tr>
                      <th>结算归类属性</th>
                      <td>{{ formData.settleTypeNames }}</td>

                      <th>品牌名称</th>
                      <td>{{ formData.brandNames }}</td>

                      <th>工单数量</th>
                      <td>{{ formData.orderQty }}</td>

                      <th>机器数量</th>
                      <td>{{ formData.machineQty }}</td>
                    </tr>
                    <tr>
                      <th>总服务费</th>
                      <td>{{ formData.siteAmount }}</td>
                      <th>安装费</th>
                      <td>{{ formData.azAmount }}</td>
                      <th>维修费</th>
                      <td>{{ formData.wxAmount }}</td>
                      <th>其他费</th>
                      <td>{{ formData.otherAmount }}</td>
                    </tr>
                    <tr>
                      <th>总远程费</th>
                      <td>{{ formData.longDistanceAmount }}</td>
                      <th>安装远程费</th>
                      <td>{{ formData.azDistanceAmount }}</td>
                      <th>维修远程费</th>
                      <td>{{ formData.wxDistanceAmount }}</td>
                      <th>其他远程费</th>
                      <td>{{ formData.otherDistanceAmount }}</td>
                    </tr>
                    <tr>
                      <th>总考核费</th>
                      <td>{{ formData.kaoheAmount }}</td>
                      <th>安装考核费</th>
                      <td>{{ formData.azKaoheAmount }}</td>
                      <th>维修考核费</th>
                      <td>{{ formData.wxKaoheAmount }}</td>
                      <th>其他考核费</th>
                      <td>{{ formData.otherKaoheAmount }}</td>
                    </tr>
                    <tr>
                      <th>总结算补扣</th>
                      <td>{{ formData.bukouAmount }}</td>
                      <th>安装补扣费</th>
                      <td>{{ formData.azBukouAmount }}</td>
                      <th>维修补扣费</th>
                      <td>{{ formData.wxBukouAmount }}</td>
                      <th>其他补扣费</th>
                      <td>{{ formData.otherBukouAmount }}</td>
                    </tr>
                    <tr>
                      <th>总特殊费用</th>
                      <td>{{ formData.teshuAmount }}</td>
                      <th>安装特殊费</th>
                      <td>{{ formData.azTeshuAmount }}</td>
                      <th>维修特殊费</th>
                      <td>{{ formData.wxTeshuAmount }}</td>
                      <th>其他特殊费</th>
                      <td>{{ formData.otherTeshuAmount }}</td>
                    </tr>
                    <tr>
                      <th>奖罚金额</th>
                      <td>{{ formData.rewardAmount }}</td>
                      <th>特设费用</th>
                      <td>{{ formData.specialAmount }}</td>
                      <th>红利</th>
                      <td>{{ formData.bonusFee ? formData.bonusFee : 0 }}</td>
                    </tr>
                    <tr>
                      <th>销售奖励</th>
                      <td>{{ formData.saleRewardAmount }}</td>
                      <th>销售奖励调整</th>
                      <td>{{ formData.saleRewardAdjustAmount }}</td>
                    </tr>
                    <tr>
                      <th>总权益核销费用</th>
                      <td>{{ formData.quanyiHexiaoAmount }}</td>
                      <th>安装权益核销</th>
                      <td>{{ formData.azQuanyiHexiaoAmount }}</td>
                      <th>维修权益核销</th>
                      <td>{{ formData.wxQuanyiHexiaoAmount }}</td>
                      <th>其他权益核销</th>
                      <td>{{ formData.otherQuanyiHexiaoAmount }}</td>
                    </tr>
                    <tr>
                      <th>安装激励费用</th>
                      <td>{{ formData.azWkRewardAmount }}</td>
                      <th>维修激励费用</th>
                      <td>{{ formData.wxWkRewardAmount }}</td>
                      <th>其他激励费用</th>
                      <td>{{ formData.otherWkRewardAmount }}</td>
                      <th>总激励费用</th>
                      <td>{{ formData.wkRewardAmount }}</td>
                    </tr>
                    <tr>
                      <th>安装奖惩费用</th>
                      <td>{{ formData.azWkPunishAmount }}</td>
                      <th>维修奖惩费用</th>
                      <td>{{ formData.wxWkPunishAmount }}</td>
                      <th>其他奖惩费用</th>
                      <td>{{ formData.otherWkPunishAmount }}</td>
                      <th>总奖惩费用</th>
                      <td>{{ formData.wkPunishAmount }}</td>
                    </tr>
                    <tr>
                      <th class="title_color">业务总金额</th>
                      <td class="title_color">{{ formData.siteFinalAmount }}</td>
                      <th>总安装费</th>
                      <td>{{ formData.siteAzAmount }}</td>
                      <th>总维修费</th>
                      <td>{{ formData.siteWxAmount }}</td>
                      <th>总其他费</th>
                      <td>{{ formData.siteOtherAmount }}</td>
                    </tr>

                    <tr v-for="item in sfSettleFeeAttributeDTOList_tr">
                      <th v-if="item.length > 0">{{ item[0].feeAttributeName }}</th>
                      <td v-if="item.length > 0">{{ item[0].amount }}</td>

                      <th v-if="item.length > 1">{{ item[1].feeAttributeName }}</th>
                      <td v-if="item.length > 1">{{ item[1].amount }}</td>

                      <th v-if="item.length > 2">{{ item[2].feeAttributeName }}</th>
                      <td v-if="item.length > 2">{{ item[2].amount }}</td>

                      <th v-if="item.length > 3">{{ item[3].feeAttributeName }}</th>
                      <td v-if="item.length > 3">{{ item[3].amount }}</td>
                    </tr>

                    <tr>
                      <th>本单调整金额</th>
                      <td>{{ formData.adjustAmount }}</td>

                      <th>本单调整原因</th>
                      <td>{{ formData.adjustReason }}</td>
                    </tr>

                    <tr>
                      <th class="title_color">总金额</th>
                      <td class="title_color">{{ formData.amount }}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <!--              <div class="d-item">-->
              <!--                <div class="title first"><b>业务金额</b></div>-->
              <!--                <div>-->
              <!--                  &lt;!&ndash; <div class="title first"><b>历史工单</b></div> &ndash;&gt;-->
              <!--                  <vxe-table :stripe="true"-->
              <!--                             style="width: 60%;margin: 5px ;"-->
              <!--                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '45%' }"-->
              <!--                             :row-config="{height: 30,isHover: true,padding: 0,}"-->
              <!--                             :row-style="{ fontSize: '12px',  }"-->
              <!--                             show-overflow height="160"-->
              <!--                             :column-config="{ resizable: true }"-->
              <!--                             :data="formData.sfSettleFeeAttributeDTOList">-->
              <!--                    <vxe-column field="feeAttributeName" title="费用名称"></vxe-column>-->
              <!--                    <vxe-column field="amount" title="金额"></vxe-column>-->
              <!--                  </vxe-table>-->
              <!--                </div>-->
              <!--              </div>-->
<!--              <div class="d-item">-->
<!--                <div class="title first"><b>发票信息</b></div>-->
<!--                <table class="table-detail">-->
<!--                  <tbody>-->

<!--                    <tr>-->
<!--                      <th>税率</th>-->
<!--                      <td>{{ formData.taxRate }}</td>-->
<!--                      <th>税额</th>-->
<!--                      <td>{{ formData.taxAmount }}</td>-->
<!--                      <th>开票时间</th>-->
<!--                      <td>{{ formData.invoiceNoDate }}</td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <th>发票号</th>-->
<!--                      <td>{{ formData.invoiceNo }}</td>-->
<!--                      <th>发票金额</th>-->
<!--                      <td>{{ formData.invoiceNoAmount }}</td>-->
<!--                    </tr>-->
<!--                  </tbody>-->
<!--                </table>-->
<!--              </div>-->

<!--              <div class="d-item">-->
<!--                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">-->
<!--                  <div class="title first"><b>发票文件</b></div>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <vxe-table style="margin-top: 0px;" :stripe="true"-->
<!--                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
<!--                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"-->
<!--                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"-->
<!--                             @checkbox-all="selectChangeEvent" :data="formData.sfBatchSettleInvoiceFileList">-->
<!--                    <vxe-column type="checkbox" width="40" />-->
<!--                    <vxe-column field="fileName" title="附件名称" width="400">-->
<!--                      <template #default="{ row }">-->
<!--                        &lt;!&ndash; <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> &ndash;&gt;-->
<!--                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>-->

<!--                      </template>-->
<!--                    </vxe-column>-->

<!--                    <vxe-column title="操作" width="90">-->
<!--                      <template #default="{ row }">-->
<!--                        &lt;!&ndash; 下载 &ndash;&gt;-->
<!--                        <div>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"-->
<!--                                      popper-class="tooltip-skin">-->
<!--                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"-->
<!--                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>-->
<!--                          </el-tooltip>-->

<!--                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"-->
<!--                                      popper-class="tooltip-skin">-->
<!--                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"-->
<!--                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>-->
<!--                          </el-tooltip>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </vxe-column>-->
<!--                  </vxe-table>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="d-item">-->
<!--                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">-->
<!--                  <div class="title first"><b>附件列表</b></div>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <vxe-table style="margin-top: 0px;" :stripe="true"-->
<!--                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
<!--                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"-->
<!--                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"-->
<!--                             @checkbox-all="selectChangeEvent" :data="formData.sfBatchSettleFileDTOList">-->
<!--                    <vxe-column type="checkbox" width="40" />-->
<!--                    <vxe-column field="fileName" title="附件名称" width="400">-->
<!--                      <template #default="{ row }">-->
<!--                        &lt;!&ndash; <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> &ndash;&gt;-->
<!--                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>-->

<!--                      </template>-->
<!--                    </vxe-column>-->

<!--                    <vxe-column title="操作" width="90">-->
<!--                      <template #default="{ row }">-->
<!--                        &lt;!&ndash; 下载 &ndash;&gt;-->
<!--                        <div>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"-->
<!--                                      popper-class="tooltip-skin">-->
<!--                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"-->
<!--                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>-->
<!--                          </el-tooltip>-->

<!--                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"-->
<!--                                      popper-class="tooltip-skin">-->
<!--                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"-->
<!--                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>-->
<!--                          </el-tooltip>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </vxe-column>-->
<!--                  </vxe-table>-->
<!--                </div>-->
<!--              </div>-->

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>结算明细</b></div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.sfSettleApplyLineDTOList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="lineType" title="类型" width="60">
                      <template #default="{ row }">
                        <span v-if="row.lineType == 1">安装费</span>
                        <span v-if="row.lineType == 2">维修费</span>
                        <span v-if="row.lineType == 9">其他费</span>
                        <span v-if="row.lineType == 0">汇总</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="yingjieZongjiner" title="应结总金额" width="80"/>
                    <vxe-column field="yijieZongjiner" title="已结总金额" width="80"/>
                    <vxe-column field="daijieZongjiner" title="待结总金额" width="80"/>
                    <vxe-column field="fapiaoZongjiner" title="发票总金额" width="80"/>
                    <vxe-column field="shifuZongjiner" title="实付总金额" width="80"/>
                    <vxe-column field="hexiaoZongjiner" title="核销总金额" width="80"/>
                  </vxe-table>
                </div>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>发票明细</b></div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.sfSettleApplyInvoiceDTOList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="invoiceNo" title="发票号" width="100" />
                    <vxe-column field="invoiceType" title="费用类型" width="60">
                      <template #default="{ row }">
                        <span v-if="row.invoiceType == 1">安装费</span>
                        <span v-if="row.invoiceType == 2">维修费</span>
                        <span v-if="row.invoiceType == 3">其他费</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="invoiceNoAmount" title="发票金额" width="80"/>
                    <vxe-column field="taxRate" title="税率" width="80">
                      <template #default="{ row }">
                        <span>{{ row.taxRate }}%</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="taxAmount" title="税金" width="80"/>
                    <vxe-column field="invoiceRemark" title="备注" width="80"/>
                    <vxe-column field="shifuZongjiner" title="发票验证" width="80">
                      <template #default="{ row }">
                        <span v-if="row.correctCheck == 0">待验证</span>
                        <span v-if="row.correctCheck == 1">已同步费控</span>
                        <span v-if="row.correctCheck == 8">验真</span>
                        <span v-if="row.correctCheck == 9">验假</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="correctCheckRemark" title="验假备注" width="80"/>
                    <vxe-column field="invoicePic" title="发票文件" width="80">
                      <template #default="{ row }">
                        <span @click="openVideo(row.invoicePic)">查看</span>

                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>付款明细</b></div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.sfSettleApplyPayDTOList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="payNo" title="付款单号" width="80"/>
                    <vxe-column field="invoiceNo" title="发票号" width="80"/>
                    <vxe-column field="payType" title="付款方式" width="80"/>
                    <vxe-column field="payAmount" title="付款金额" width="80"/>
                    <vxe-column field="payRemark" title="备注" width="80"/>
                  </vxe-table>
                </div>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>调整金额附件</b></div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.sfBatchSettleAdjustFileDTOList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{ row }">
                        <!-- <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> -->
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                      </template>
                    </vxe-column>

                    <vxe-column title="操作" width="90">
                      <template #default="{ row }">
                        <!-- 下载 -->
                        <div>
                        </div>
                        <div>
                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>

              <!-- 业务信息 -->
<!--              <div class="d-item">-->
<!--                <div class="title first"><b>付款信息</b></div>-->
<!--                <table class="table-detail">-->
<!--                  <tbody>-->

<!--                    <tr>-->
<!--                      <th>付款方式</th>-->
<!--                      <td v-if="formData.payType == 1">银行汇款</td>-->
<!--                      <td v-else-if="formData.payType == 2">转货款</td>-->
<!--                      <td v-else-if="formData.payType == 3">转配件款</td>-->
<!--                      <td v-else></td>-->

<!--                      <th>转货款金额</th>-->
<!--                      <td>{{ formData.zhkAmount }}</td>-->
<!--                      <th>转配件款金额</th>-->
<!--                      <td>{{ formData.zpjAmount }}</td>-->
<!--                      <th>其他金额</th>-->
<!--                      <td>{{ formData.qtAmount }}</td>-->
<!--                    </tr>-->
<!--                    <tr>-->


<!--                      <th>付现金额</th>-->
<!--                      <td>{{ formData.realpayAmount }}</td>-->

<!--                      <th>银行名称</th>-->
<!--                      <td>{{ formData.bankName }}</td>-->

<!--                      <th>银行帐号</th>-->
<!--                      <td>{{ formData.bankAccount }}</td>-->
<!--                      <th>银行帐户</th>-->
<!--                      <td>{{ formData.bankAccountName }}</td>-->
<!--                    </tr>-->


<!--                  </tbody>-->
<!--                </table>-->
<!--              </div>-->

              <div class="d-item">
                <div class="title first"><b>其他信息</b></div>
                <table class="table-detail">
                  <tbody>

                    <tr>
                      <th>
                        审核时间
                      </th>
                      <td>{{ formData.checkDate }}</td>


                      <th>
                        结算时间
                      </th>
                      <td>
                        {{ formData.payDate }}
                      </td>
                      <th>
                        结算备注
                      </th>
                      <td colspan="3">
                        {{ formData.payRemark }}
                      </td>

                    </tr>

                    <tr>
                      <th>
                        单据时间段
                      </th>
                      <td>{{ formData.orderDates }}</td>


                      <th>
                        代理对象
                      </th>
                      <td v-if="formData.proxyObject == 0">无代理</td>
                      <td v-else-if="formData.proxyObject == 1">结算代理网点</td>
                      <td v-else-if="formData.proxyObject == 2">被代理结算的网点</td>
                      <td v-else></td>

                      <th>
                        代理结算单
                      </th>
                      <td>
                        {{ formData.proxyNo }}
                      </td>


                    </tr>
                  </tbody>
                </table>
              </div>

              <div style="height:160px"></div>
            </div>
            <div style="width: 20%;" class="bread">
              <div style="padding-bottom: 90px;    margin-top: 10px; margin-left: 5px;">
                <div class="title_icon"><i class="el-icon-date"></i></div>
                <span>申请过程</span>
                <el-timeline class="card_bread" style="position:relative">

                  <el-timeline-item v-for="item in formData.sfBatchSettleOperationDTOList" placement="top">
                    <div class="title_time"><span class="span1">{{ item.title }}</span>
                      <span class="span2">{{ item.createTime }}</span>
                    </div>
                    <el-card class="card">
                      <p>{{ item.content }}</p>
                    </el-card>
                  </el-timeline-item>


                  <!--                  <el-timeline-item-->
                  <!--                    v-for="item in tenant.soOrderOperationDTOList1.slice(3, tenant.soOrderOperationDTOList1.length)"-->
                  <!--                    :timestamp="item.createTime" placement="top">-->
                  <!--                    <el-card class="card">-->
                  <!--                      <div>{{ item.title }}</div>-->
                  <!--                      <p>{{ item.content }}</p>-->
                  <!--                    </el-card>-->
                  <!--                  </el-timeline-item>-->


                </el-timeline>

              </div>
            </div>
          </dix>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>{{ dialogMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>

      <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true" />
      <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true" />
      <!-- 异议处理 -->
      <objectionHandlingDialog v-if="applicationHandleDialog" :id="currentRowId" :visiable.sync="applicationHandleDialog"
        multi="true" @goBackIndex="goBackIndex" />
      <!-- 调整金额 -->
      <adjustAmountDialog v-if="applicationAdjustDialog" :id="currentRowId" :visiable.sync="applicationAdjustDialog"
        multi="true" @goBackIndex="goBackIndex" />
      <!-- 确认 -->
      <confirmDialog v-if="applicationConfirmDialog" :id="currentRowId" :visiable.sync="applicationConfirmDialog"
        multi="true" @goBackIndex="goBackIndex" />
      <!-- 上传发票 -->
      <uploadInvoiceDialog v-if="applicationInvoiceDialog" :id="currentRowId" :visiable.sync="applicationInvoiceDialog"
        multi="true" @goBackIndex="goBackIndex" />

      <!-- 批量通知 -->
      <batchPassDialog :param="{ idList: currentRow.idList, type: currentRow.type }" v-if="showBatchPassDialog"
        :visiable.sync="showBatchPassDialog" @goBackIndex="goBackIndex" multi="true" />
      <!-- 结算完成 -->
      <batchSettleDialog :param="{ idList: currentRow.idList, type: currentRow.type }" v-if="showBatchSettleDialog"
        :visiable.sync="showBatchSettleDialog" @goBackIndex="goBackIndex" multi="true" />
      <!-- 取消结算 -->
      <batchCancelDialog :param="{ idList: currentRow.idList, type: currentRow.type }" v-if="showBatchCancelDialog"
        :visiable.sync="showBatchCancelDialog" @goBackIndex="goBackIndex" multi="true" />

      <!-- 查看结算明细 -->
      <viewDetails v-if="viewDetailsDialog" :id="currentRowId" :visiable.sync="viewDetailsDialog" multi="true"
        @goBackIndex="goBackIndex" />

      <!-- 驳回发票 -->
      <applicationRejectDialog v-if="applicationRejectDialog" :id="currentRowId"
                               :visiable.sync="applicationRejectDialog" multi="true"
                               @goBackIndex="goBackIndex" />

      <Preview v-if="showPreview" @closeD="closeD33" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />


    </div>
  </div>
</template>

<script>

import request from "@/router/axios";

import store from "@/store";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";
// 查看明细
import viewDetails from './viewDetailsDialog.vue';
import objectionHandlingDialog from '@/views/finance/cost/application/handlingDialog.vue';
import adjustAmountDialog from '@/views/finance/cost/application/adjustAmountDialog.vue';
import confirmDialog from '@/views/finance/cost/application/confirmDialog.vue';
import uploadInvoiceDialog from '@/views/finance/cost/application/invoiceDialog.vue';
import batchPassDialog from '@/views/finance/cost/application/batchPassDialog.vue';
import batchSettleDialog from '@/views/finance/cost/application/batchSettleDialog.vue';
import batchCancelDialog from '@/views/finance/cost/application/batchCancelDialog.vue';
import applicationRejectDialog from '@/views/finance/cost/application/rejectDialog.vue';
//图片
import photoUpload from "@/components/formItem/photoUpload.vue";
import { doCheckExcle, doDownLoadExcle, doDownLoadExcleWithoutRecord, getBlob } from '@/api/intfDownloadRecord/downloadRecord.js';
import fileNames from "@/api/intfDownloadRecord/fileNames.js";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Preview,
    photoUpload,
    viewDetails,
    objectionHandlingDialog,
    adjustAmountDialog,
    confirmDialog,
    uploadInvoiceDialog,
    batchPassDialog,
    batchSettleDialog,
    batchCancelDialog,
    applicationRejectDialog
  },
  data() {
    return {
      imgVisbleURL: '',
      showPreview: false,
      isSite: false,
      viewDetailsDialog: false,
      applicationHandleDialog: false,
      applicationCancelDialog: false,
      applicationAdjustDialog: false,
      applicationInvoiceDialog: false,
      applicationSettleDialog: false,
      applicationConfirmDialog: false,
      applicationInvoice: false,
      applicationRejectDialog: false,

      showBatchPassDialog: false,
      showBatchSettleDialog: false,
      showBatchCancelDialog: false,

      dialogMsg: null,
      dialogVisible: false,

      formData: {
        invoicePic: null,
        settleNo: null,  // 结算单号:前缀"S"+年月日+6位流水号
        stat: 0,  // 状态：0未提交;1提交未审核;5审核待结算;9驳回;19已结算;99取消
        orgId: 0,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: 0,  // 网点ID,关联sn_user.id;
        settleType: 0,  // 结算归类属性:1安装、2维修、29其他
        brandId: 0,  // 品牌ID,关联sn_company_brand.id
        brandName: null,  // 品牌名称,冗余字段;
        orderQty: 0,  // 工单数量
        machineQty: 0,  // 机器数量
        siteAmount: 0,  // 服务费
        rewardAmount: 0,  // 奖罚金额
        longDistanceAmount: 0,  // 远程费
        specialAmount: 0,  // 特设费用
        siteFinalAmount: 0,  // 业务总金额:以上金额+自定义费用项(sf_settle_fee_attribute.amount)之和
        adjustAmount: 0,  // 本单调整金额：由调整金额操作给定
        adjustReason: null,  // 本单调整原因：由调整金额操作给定
        amount: 0,  // 总金额:业务总金额+本单调整金额
        taxRate: 0,  // 税率
        taxAmount: 0,  // 税额
        invoiceStat: 0,  // 发票状态：0未通知开票;1已通知开票;3网点已开票;5分公司已接收;7总部已接收;9已建结算批;98已驳回
        invoiceNoDate: null,  // 开票时间（由录发票号时指定）
        invoiceNo: null,  // 发票号（由录发票号时指定）
        invoiceNoAmount: 0,  // 发票金额（由录发票号时指定）
        payType: 0,  // 付款方式：1银行汇款;2转货款;3转配件款
        zhkAmount: 0,  // 转货款金额
        zpjAmount: 0,  // 转配件款金额
        qtAmount: 0,  // 其他金额
        realpayAmount: 0,  // 付现金额:由总金额-转货款金额-转配件款金额-其他金额得来
        bankName: null,  // 银行名称
        bankAccount: null,  // 银行帐号
        bankAccountName: null,  // 银行帐户
        checkDate: null,  // 审核时间
        payDate: null,  // 结算时间
        payRemark: null,  // 结算备注
        orderDates: null,  // 单据时间段
        proxyObject: 0,  // 代理对象：0无代理;1结算代理网点;2被代理结算的网点
        proxySettleId: 0,  // 代理结算单:关联sf_batch_settle.id

        siteName: null,
        proxyNo: null,
        sfBatchSettleOperationDTOList: null,
        sfSettleFeeAttributeDTOList: null
      },
      sfSettleFeeAttributeDTOList_tr: [],
      // sfSettleFeeAttributeDTOList_td: [],

      show3: false,

      srcList: [],
      showPhotoList0: [],

      showEdit: false,


      isEdit: false,
      dataId: '',

      showProductCategoryDialog: false,

    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;

    this.applicationHandle = this.permissions["applicationHandle"];
    this.applicationCancel = this.permissions["applicationCancel"];
    this.applicationAdjust = this.permissions["applicationAdjust"];
    this.applicationInvoice = this.permissions["applicationInvoice"];
    this.applicationSettle = this.permissions["applicationSettle"];
    this.applicationExport = this.permissions["applicationExport"];

    this.applicationNotice = this.permissions["applicationNotice"];
    this.applicationConfirm = this.permissions["applicationConfirm"];
    this.applicationUpload = this.permissions["applicationUpload"];

    this.applicationLine = this.permissions["applicationLine"];
    this.sfBatchSettleLineExport = this.permissions["sfBatchSettleLineExport"];

    this.zbApplicationUpload = this.permissions["zbApplicationUpload"];

    const userInfo = store.getters.userInfo;
    console.log("网点信息:-------",store.getters.userInfo)
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log("是否为服务商" + this.isSite)

    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    // this.initTableList();
    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    closeD33() {
      this.showPreview = false
    },
    // 下载图片
    downDocument(name,url){
      console.log(name,url, "打开");
      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()

    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }
    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },



    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfBatchSettle.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (data.sfSettleFeeAttributeDTOList != null) {
            this.sfSettleFeeAttributeDTOList_tr = []
            let flag = 0
            let temp = []
            data.sfSettleFeeAttributeDTOList.forEach(item => {
              if (flag < 4) {
                flag += 1
              } else {
                this.sfSettleFeeAttributeDTOList_tr.push(temp)
                flag = 0
                temp = []
              }
              temp.push(item)
            })
            if (temp.length > 0) {
              this.sfSettleFeeAttributeDTOList_tr.push(temp)
            }
          }
          if (!data.sfBatchSettleOperationDTOList) {
            data.sfBatchSettleOperationDTOList = []
          }
          console.log(this.sfSettleFeeAttributeDTOList_tr, 'tr_list')
          this.formData = data
        })
      } else {
        this.enabled = true;
      }
    },

    handleCommand(command, row) {
      this.currentRowId = row
      console.log(command, row, "command,b的值");
      if (command === '异议处理') {
        this.applicationHandleDialog = true
      } else if (command === '调整金额') {
        this.applicationAdjustDialog = true
      } else if (command === '收票') {
        this.dialogMsg = '确定收票吗？'
        this.stat = 1
        this.dialogVisible = true
      } else if (command === '结算完成') {
        this.applicationSettle()
      } else if (command === '取消结算') {
        this.applicationCancelDialog = true
      } else if (command === '确认') {
        this.applicationConfirmDialog = true
      } else if (command === '上传发票') {
        this.applicationInvoiceDialog = true
      }else if(command === '驳回'){
        this.applicationRejectDialog = true
      }else if(command ==='付款申请'){
        this.$router.push({ path: '/finance/settleApply/index', query: { settleId: this.formData.id } })
      }
    },

    //     // 文件下载
    handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },

    confirm() {
      this.$mask.open()
      this.$http({
        url: api.sfBatchSettle.invoiceDataUrl,
        method: 'post',
        data: {
          id: this.currentRowId,
          stat: this.stat
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.$mask.close()
        this.getData();
      })
      this.dialogVisible = false
    },

    viewApplicationDetails(row) {
      this.currentRowId = row
      console.log(row, "command,b的值");
      this.viewDetailsDialog = true
    },


    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },

    //导出明细
    doExcleDetail() {
      this.$mask.open()
      doDownLoadExcleWithoutRecord(api.sfBatchSettle.doExcelUrl, this.formData).then((res) => {
        getBlob(res, fileNames.batchSettleLine)
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })

      // doCheckExcle(fileNames.settleDetail).then(response => {
      //   if (response.data.msg=="success"){
      //     doDownLoadExcle(api.sfBatchSettle.doExcelUrl, this.formData).then(res => {
      //       this.$mask.close()
      //       this.$message({
      //         type: res.data.type,
      //         message: res.data.content
      //       })
      //     }).catch(() => {
      //       this.$mask.close()
      //     })
      //   }else{
      //     this.$mask.close()
      //     this.$message({
      //       type: "error",
      //       message: response.data.msg
      //     });
      //   }
      // }).catch(() => {
      //   this.$mask.close()
      // })
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}



::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  ;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
.FileName{
  display: inline-block;
    width: 140px;
    height: 40px;
margin-right: 10px;
    border-radius: 2px;
    color: #606266;
    border-color: rgb(232, 232, 232);
    margin-top: 0px;

    background-color: rgb(233, 233, 233);
    padding: 0px !important;
}
</style>
